var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { staticClass: "pb-5" },
    [
      _c(
        "v-col",
        { staticClass: "py-0", attrs: { cols: "12" } },
        [
          _c(
            "v-toolbar",
            { attrs: { color: "transparent", flat: "", height: "45" } },
            [
              _c("v-spacer"),
              _c(
                "v-toolbar-items",
                [
                  _c(
                    "v-row",
                    {
                      attrs: {
                        align: "center",
                        justify: "end",
                        "no-gutters": "",
                      },
                    },
                    [
                      _vm.$helpers.hasPermission(["add_group"])
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                to: {
                                  name: "AccountGroupsCreate",
                                  params: _vm.currentParams,
                                },
                                color: "grey-900",
                              },
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-account-multiple-plus"),
                              ]),
                              _vm._v("Crear rol"),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.$store.state.accounts.LoaderMe
        ? [
            !_vm.$helpers.hasSomePermission(["view_group"])
              ? _c("PermissionDenied")
              : [
                  _vm.loading
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [_c("skeleton-list")],
                        1
                      )
                    : [
                        _vm.groupsList?.length
                          ? _c(
                              "v-col",
                              { attrs: { cols: "12" } },
                              [
                                _c(
                                  "v-row",
                                  _vm._l(_vm.groupsList, function (group, i) {
                                    return _c(
                                      "v-col",
                                      {
                                        key: i,
                                        attrs: {
                                          cols: "5",
                                          md:
                                            _vm.$vuetify.breakpoint.width < 1200
                                              ? 4
                                              : 3,
                                        },
                                      },
                                      [
                                        _c("v-hover", {
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ hover }) {
                                                  return [
                                                    _c(
                                                      "v-card",
                                                      {
                                                        staticClass:
                                                          "pa-5 rounded-md",
                                                        attrs: {
                                                          elevation: hover
                                                            ? 5
                                                            : 0,
                                                          flat: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.$router.push(
                                                              {
                                                                name: "AccountGroupsUpdate",
                                                                params: {
                                                                  id: group.id,
                                                                  ..._vm.currentParams,
                                                                },
                                                              }
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-row",
                                                          {
                                                            attrs: {
                                                              "no-gutters": "",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "mb-1",
                                                                attrs: {
                                                                  color:
                                                                    "grey-900",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-account-group"
                                                                ),
                                                              ]
                                                            ),
                                                            _c("v-spacer"),
                                                            _c(
                                                              "v-menu",
                                                              {
                                                                attrs: {
                                                                  "close-on-click":
                                                                    "",
                                                                  "close-on-content-click":
                                                                    "",
                                                                  "offset-y":
                                                                    "",
                                                                  left: "",
                                                                  "nudge-bottom": 0,
                                                                  "nudge-left": 10,
                                                                  transition:
                                                                    "slide-y-transition",
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "activator",
                                                                        fn: function ({
                                                                          on,
                                                                          attrs,
                                                                        }) {
                                                                          return [
                                                                            _c(
                                                                              "v-btn",
                                                                              _vm._g(
                                                                                _vm._b(
                                                                                  {
                                                                                    staticClass:
                                                                                      "mt-n1 mr-n2",
                                                                                    attrs:
                                                                                      {
                                                                                        text: "",
                                                                                      },
                                                                                  },
                                                                                  "v-btn",
                                                                                  attrs,
                                                                                  false
                                                                                ),
                                                                                on
                                                                              ),
                                                                              [
                                                                                _c(
                                                                                  "v-icon",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        color:
                                                                                          "grey-700",
                                                                                        size: "24",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "mdi-dots-vertical"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ]
                                                                        },
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                                model: {
                                                                  value:
                                                                    _vm.menu[i],
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.menu,
                                                                        i,
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "menu[i]",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list",
                                                                  {
                                                                    staticClass:
                                                                      "pa-0",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-list-item",
                                                                      {
                                                                        staticClass:
                                                                          "px-3",
                                                                        attrs: {
                                                                          to: {
                                                                            name: "AccountGroupsUpdate",
                                                                            params:
                                                                              {
                                                                                id: group.id,
                                                                                ..._vm.currentParams,
                                                                              },
                                                                          },
                                                                          ripple: false,
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-list-item-title",
                                                                          {
                                                                            staticClass:
                                                                              "body-2",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Ver información del rol"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _c(
                                                                      "v-list-item",
                                                                      {
                                                                        staticClass:
                                                                          "px-3",
                                                                        attrs: {
                                                                          "active-class":
                                                                            "transparent",
                                                                          ripple: false,
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$router.replace(
                                                                                {
                                                                                  name: "AccountGroupsUpdate",
                                                                                  params:
                                                                                    {
                                                                                      id: group.id,
                                                                                      ..._vm.currentParams,
                                                                                    },
                                                                                  query:
                                                                                    {
                                                                                      users: true,
                                                                                    },
                                                                                }
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-list-item-title",
                                                                          {
                                                                            staticClass:
                                                                              "body-2",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Ver lista de usuarios"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "d-block",
                                                          },
                                                          [
                                                            _c(
                                                              "v-sheet",
                                                              {
                                                                staticClass:
                                                                  "transparent",
                                                                attrs: {
                                                                  height: "25",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "grey-700--text font-weight-medium body-1 d-inline-block text-truncate",
                                                                    staticStyle:
                                                                      {
                                                                        "max-width":
                                                                          "99%",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        group.name
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "d-block mt-n1 mb-1",
                                                          },
                                                          [
                                                            _c(
                                                              "v-sheet",
                                                              {
                                                                staticClass:
                                                                  "transparent",
                                                                attrs: {
                                                                  height: "25",
                                                                },
                                                              },
                                                              [
                                                                group.description
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "grey-700--text font-weight-medium body-1 d-inline-block text-truncate",
                                                                        staticStyle:
                                                                          {
                                                                            "max-width":
                                                                              "99%",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            group.description
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "body-2 text--disabled font-italic",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Sin especificar"
                                                                        ),
                                                                      ]
                                                                    ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _vm.$helpers.hasPermission(
                                                          ["view_member"]
                                                        )
                                                          ? [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "mt-n2 d-block body-2 grey-300--text d-inline-block d-inline-block text-truncate font-weight-medium",
                                                                  staticStyle: {
                                                                    "max-width":
                                                                      "99%",
                                                                    "line-height":
                                                                      "22px",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        group
                                                                          ?.members
                                                                          ?.length
                                                                      ) +
                                                                      " " +
                                                                      _vm._s(
                                                                        `miembro${
                                                                          group
                                                                            ?.members
                                                                            ?.length !==
                                                                          1
                                                                            ? "s"
                                                                            : ""
                                                                        }`
                                                                      )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    )
                                  }),
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { staticClass: "py-0" },
                                  [
                                    _c("VMainPagination", {
                                      attrs: { count: _vm.groupsList?.length },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _c(
                              "v-col",
                              [
                                _c("v-empty-state", {
                                  attrs: {
                                    type: "groups",
                                    id: "roles",
                                    isFree: true,
                                    title: "No existen roles para mostrar",
                                    customClass: "mt-5",
                                  },
                                }),
                              ],
                              1
                            ),
                      ],
                ],
          ]
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "600",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogDelete,
            callback: function ($$v) {
              _vm.dialogDelete = $$v
            },
            expression: "dialogDelete",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { color: "transparent", flat: "", height: "46" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Eliminar rol")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogDelete = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "py-4 px-5 grey-500--text" },
                [
                  _c("span", { staticClass: "d-block" }, [
                    _vm._v(
                      "Al eliminar el rol, los usuarios asociados quedarán con todos los permisos activos"
                    ),
                  ]),
                  _c("span", { staticClass: "d-block mt-4 mb-3" }, [
                    _vm._v("Escribe "),
                    _c("span", { staticClass: "font-weight-bold" }, [
                      _vm._v("“confirmar”"),
                    ]),
                    _vm._v(" para continuar."),
                  ]),
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      "single-line": "",
                      maxlength: "9",
                      dense: "",
                      "hide-details": "",
                    },
                    model: {
                      value: _vm.confirm,
                      callback: function ($$v) {
                        _vm.confirm = $$v
                      },
                      expression: "confirm",
                    },
                  }),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogDelete = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        disabled: _vm.confirm.toLowerCase() !== "confirmar",
                      },
                      on: { click: _vm.destroyGroup },
                    },
                    [_vm._v("Confirmar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }